import React from "react";
import { Modal } from "react-bootstrap";
import { useRecoilState } from "recoil";
import { isModalAtom } from "../atoms";

import LoginModal from "./modals/loginModal";
import AlertModal from "./modals/alertModal";
import BoardcontModdal from "./modals/boardcontModal";
import UserModal from "./modals/userModal";

function AModal() {
  const handleClose = () => setisMocalopen(false);
  const [isMocalopen, setisMocalopen] = useRecoilState(isModalAtom);

  return (
    <>
      {/* Login Modal */}
      <Modal show={isMocalopen === "login"} onHide={handleClose}>
        <LoginModal />
      </Modal>

      {/* Alert Modal */}
      <Modal show={isMocalopen === "alert"} onHide={handleClose}>
        <AlertModal />
      </Modal>

      {/* User Modal */}
      <Modal show={isMocalopen === "user"} onHide={handleClose}>
        <UserModal />
      </Modal>

      {/* Board Content Modal */}
      <Modal
        size="lg"
        scrollable="true"
        show={isMocalopen === "boardcont"}
        onHide={handleClose}
      >
        <BoardcontModdal />
      </Modal>
    </>
  );
}

export default AModal;
